import { LitElement, html } from "lit-element";
import { SharedStyles } from "../../../../styles/shared-styles";

export class DrawFreedrawModule extends LitElement {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.canvas.isDrawingMode = true;
		this.canvas.freeDrawingBrush.color = this.__getColor();
		this.canvas.freeDrawingBrush.width = this.brushWidth;
		return this;
	}

	Deactivate() {
		this.canvas.defaultCursor = "default";
		this.canvas.isDrawingMode = false;
	}

	render() {
		return html`
            ${SharedStyles}
            <style>
                :host {
                   width: 100%;
                }

                .widths {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    margin-top: 5px;
                    justify-content: start;
                }
            
                .widths label {
                    display: block;
                    height: 40px;
                    cursor: pointer;
                    text-align: center;
                    font-size: 12px;
                    width: 100%;
                    padding: 5px;
                }

                .widths label:before {
                    content: '';
                    display: block;
                    background-color: var(--selected-color, white);
                }
            </style>
            <style>
                ${this._renderClass(this.brushWidth, this.index)}
            </style>
           
            <div class="widths">
                ${this._renderItem(this.brushWidth, this.index)}
            </div>`;
	}

	_renderClass(i, index) {
		return `.width-item-${index}:before { height: ${i}px; }`;
	}

	_renderItem(i, index) {
		const cls = "width-item-" + index;
		return html`<label @click="${e =>
			this._handleChangeEvent(e, i)}" class="${cls}">${i} px</label>`;
	}

	_handleChangeEvent(e, i) {
		let target = e.currentTarget;
		for (let element of target.parentElement.children) 
			element.removeAttribute("selected");
		
		target.setAttribute("selected", "selected");

		this.brushWidth = i;
		this.canvas.freeDrawingBrush.width = this.brushWidth;
	}

	static get properties() {
		return { brushWidth: String };
	}

	constructor(canvas, getColor, width, index) {
		super();
		this.canvas = canvas;
		this.__getColor = getColor;
		this.brushWidth = width;
		this.index = index;
	}
}

window.customElements.define("inspx-draw-freedraw-module", DrawFreedrawModule);
